module.exports = __webpack_public_path__ + "img/4A6442_D0AB75_81CD94_181B12-256px.1ae20533.png";